export default __webpack_public_path__ + "static/media/skewRight.d66284f5.png";